import { render, staticRenderFns } from "./CourseItemOrder.vue?vue&type=template&id=c9a254c2&scoped=true&"
import script from "./CourseItemOrder.vue?vue&type=script&lang=js&"
export * from "./CourseItemOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a254c2",
  null
  
)

export default component.exports